// Искра ряда в карточке платформы: путь SVG и границы для подписи.
//
// Чистая геометрия, потому что врать она может тихо: ряд, прижатый к нулю, или
// перевёрнутая ось читаются как факт о величине, а не как ошибка отрисовки.

export interface SparkPoint {
  value: number
}

export interface SparkBounds {
  min: number
  max: number
  first: number
  last: number
}

/** Границы ряда — для подписи под искрой. `null`, если ряда нет. */
export function sparklineBounds(points: SparkPoint[]): SparkBounds | null {
  const values = points.map(p => p.value).filter(v => Number.isFinite(v))
  if (values.length === 0) return null
  return {
    min: Math.min(...values),
    max: Math.max(...values),
    first: values[0],
    last: values[values.length - 1],
  }
}

/** Путь `d` для `<path>`: слева направо, большее значение — выше.
 *
 *  Одна точка линии не даёт: это было бы утверждение о ходе величины, которого
 *  мы не делали. Плоский ряд идёт по СЕРЕДИНЕ рамки — прижатый к низу, он
 *  читался бы как падение в ноль. */
export function sparklinePath(points: SparkPoint[], width: number, height: number): string {
  const values = points.map(p => p.value).filter(v => Number.isFinite(v))
  if (values.length < 2) return ''

  const min = Math.min(...values)
  const max = Math.max(...values)
  const span = max - min

  const step = width / (values.length - 1)
  const y = (v: number) => (span === 0 ? height / 2 : height - ((v - min) / span) * height)

  return values
    .map((v, i) => `${i === 0 ? 'M' : 'L'}${(i * step).toFixed(1)} ${y(v).toFixed(1)}`)
    .join('')
}
